import { css } from "styled-components";
import token from "styled-token";
import { spaceMixin } from "../spaceMixin";
import { typographyMixin } from "../typographyMixin";
/** @class SliderLabelMixin */

/** @method */

export var SliderLabelMixin = function SliderLabelMixin(props) {
  return token({
    backgroundColor: "SliderLabel.backgroundColor",
    borderRadius: "radii.md",
    caretSize: "SliderLabel.caretSize",
    fontColor: "SliderLabel.fontColor",
    fontType: "SliderLabel.fontType",
    boxShadow: "Dialog.boxShadow"
  }, function (_ref) {
    var backgroundColor = _ref.backgroundColor,
        borderRadius = _ref.borderRadius,
        caretSize = _ref.caretSize,
        fontColor = _ref.fontColor,
        fontType = _ref.fontType,
        boxShadow = _ref.boxShadow;
    return css(["display:inline-flex;background:", ";border-radius:", "px;padding:", " ", ";", " color:", ";box-shadow:", ";flex-direction:column;align-items:center;&:after{content:\"\";border-top:", "px solid ", ";border-left:", "px solid transparent;border-right:", "px solid transparent;margin-bottom:-", ";position:relative;top:", "px;}_:-ms-fullscreen &,&{left:-12px;}_:-ms-fullscreen &,&:after{margin-right:-", "px;top:38px;right:100%;}"], backgroundColor, borderRadius, spaceMixin("xs")(props), spaceMixin(1.5)(props), typographyMixin(Object.assign({
      fontType: fontType
    }, props)), fontColor, boxShadow, caretSize, backgroundColor, caretSize, caretSize, spaceMixin("xs")(props), caretSize, caretSize * 2);
  });
};